<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('withdraw.with_record')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="topInfo">
            <span class="status" :class="getStatusClass(v.status)">
              {{ getStatusText(v.status) }}
            </span>
            <span class="money">-{{v.money}}</span>
          </div>
          <div class="desc">
            <span>{{$t("withdraw.desc")}}：{{v.desc}}</span>
          </div>
          <div class="time">
            <span>{{$t("withdraw.submit_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("withdraw.check_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: []
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getUserWithdrawList();
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getStatusText(status) {
      if (status === 3) return this.$t('foorter.top30');
      if (status === 2) return this.$t('foorter.top29');
      return this.$t('foorter.top28');
    },
    getStatusClass(status) {
      if (status === 3 || status === 2) return 'success';
      return 'pending';
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
}

/* 顶部导航栏 */
.header {
  background: #fff;
}

.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #333;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #333;
  }
}

/* 主内容区域 */
.container .main {
  position: relative;
  overflow-y: auto;
  background-color: #f7f8fa;
  min-height: calc(100VH - 50PX);
  padding: 10PX;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #333;
  font-size: 14PX;
}

::v-deep .van-loading__text {
  color: #333;
  font-size: 14PX;
}

/* 记录卡片 */
.item_list {
  padding: 20PX 15PX;
  margin: 12PX 10PX;
  background: #fff;
  border-radius: 12PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
}

/* 顶部状态和金额 */
.item_list .topInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12PX;
}

.item_list .topInfo .status {
  font-size: 14PX;
  font-weight: 600;
  padding: 4PX 12PX;
  border-radius: 20PX;
}

.item_list .topInfo .status.success {
  color: #07c160;
  background: rgba(7, 193, 96, 0.1);
}

.item_list .topInfo .status.pending {
  color: #ff9800;
  background: rgba(255, 152, 0, 0.1);
}

.item_list .topInfo .money {
  font-size: 20PX;
  font-weight: 700;
  color: #ff253f;
}

/* 描述信息 */
.item_list .desc {
  margin-bottom: 8PX;
}

.item_list .desc span {
  font-size: 14PX;
  color: #666;
  line-height: 20PX;
}

/* 时间信息 */
.item_list .time {
  margin-bottom: 4PX;
}

.item_list .time span {
  font-size: 13PX;
  color: #999;
  line-height: 20PX;
}
</style>